import { IProductContext } from '@x/ecommerce-shop/app/core/region/state/region.state';
import { IShopAddressInput, IShopGeoRegionDetail } from '@x/ecommerce/shop-client';
import { PointInput } from '@x/schemas/ecommerce';

export class RegionSet {
  static readonly type = '[Region] Set Region';
  constructor(public region: IShopGeoRegionDetail) {}
}

export class RegionSetFromAddressInput {
  static readonly type = '[Region] Set From Address Input';
  constructor(public addressInput: IShopAddressInput) {}
}

export class RegionOpenOverlay {
  static readonly type = '[Region] open overlay';
  constructor(public productContext?: IProductContext) {}
}

export class RegionCloseOverlay {
  static readonly type = '[Region] close overlay';
}

export class RegionUpdateCoordinates {
  static readonly type = '[Region] update coordinates';
  constructor(public coordinates: PointInput) {}
}
